module.exports = __webpack_public_path__ + "static/img/52.75ef678.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/52.png
// module id = E9Gr
// module chunks = 73